export const POPULAR_ITEM_MINIMUM_SAVE_COUNT = 15;
